import React from "react";
import Capabilities from "./Capabilities";
import {
  ADDITIONAL_SCOPE_CHIP_CLASS,
  ADDITIONAL_SCOPE_DIVIDER_CLASS,
} from "../utils/scopeDisplayUtils";

/**
 * Renders predefined service category badges, optional divider, and Additional Scope chips.
 * Matches the Assessment Details Scope row pattern (US 13961).
 */
const ScopeWithAdditionalTags = ({
  services,
  additionalScope,
  showAdditionalScope = true,
  capabilitiesProps = {},
}) => {
  const tags =
    showAdditionalScope && Array.isArray(additionalScope)
      ? additionalScope.filter(Boolean)
      : [];
  const hasTags = tags.length > 0;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Capabilities services={services || []} {...capabilitiesProps} />
      {hasTags && (
        <>
          <div className={ADDITIONAL_SCOPE_DIVIDER_CLASS} />
          {tags.map((tag, index) => (
            <span key={`${tag}-${index}`} className={ADDITIONAL_SCOPE_CHIP_CLASS}>
              {tag}
            </span>
          ))}
        </>
      )}
    </div>
  );
};

export default ScopeWithAdditionalTags;
